/**
 * Hook per verificare i permessi utente
 */
import { useTenant } from "../App";

// Mapping path -> permission key (deve corrispondere a TenantLayout)
const pathToPermission = {
  "dashboard": "dashboard",
  "fatture": "fatture",
  "movimenti": "movimenti",
  "movimenti-carte": "movimenti",
  "riconciliazioni": "movimenti",
  "scadenziario": "scadenzario",
  "tesoreria": "tesoreria",
  "cash-flow": "tesoreria",
  "scadenze-ricorrenti": "scadenzario",
  "tesoreria-anagrafiche": "tesoreria_anagrafiche",
  "conti": "conti",
  "centri-costo": "centri_costo",
  "modalita-pagamento": "modalita_pagamento",
  "categorie-immobilizzazioni": "categorie_immobilizzazioni",
  "piano-ammortamenti": "piano_ammortamenti",
  "costi-extra": "costi_extra",
  "bilancio-competenza": "bilancio_competenza",
  "movimenti-patrimoniali": "report_cdc",
  "ripartizione-costi": "report_cdc",
  "appartamenti": "appartamenti",
  "alloggi-dipendenti": "appartamenti",
  "bollette": "bollette",
  "report-affitti": "appartamenti",
  "automezzi": "automezzi",
  "asset": "asset",
  "asset-spostamenti": "asset_spostamenti",
  "ddt": "ddt",
  "progetti": "progetti",
  "compiti": "progetti",
  "gestione-utenti": "gestione_utenti",
  "dipendenti": "dipendenti",
};

export function usePermissions() {
  const { user } = useTenant() || {};

  const hasPermission = (pathOrKey, type = 'view') => {
    if (!user) return false;
    if (user.ruolo === 'admin') return true;
    
    // Cerca prima come path, poi come key diretto
    const permKey = pathToPermission[pathOrKey] || pathOrKey;
    const perms = user.permissions || {};
    const perm = perms[permKey];
    
    if (typeof perm === 'object') {
      return type === 'edit' ? perm.edit : perm.view;
    }
    return !!perm;
  };

  const canView = (pathOrKey) => hasPermission(pathOrKey, 'view');
  const canEdit = (pathOrKey) => hasPermission(pathOrKey, 'edit');
  const isAdmin = user?.ruolo === 'admin';

  return { canView, canEdit, isAdmin, user };
}

export default usePermissions;
